import React from 'react'

function CheckBoxInput({
    name,
    label,
    disabled,
    value,
    onChange,
    onBlur,
    error,
}) {
    return (
        <div className='flex items-center space-x-2 text-xs sm:text-sm'>
            <input
                id={name}
                name={name}
                type="checkbox"
                disabled={disabled}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                checked={value}
                className='w-10 h-10 lg:w-8 lg:h-8 2xl:w-6 2xl:h-6'
            />
            <label for={name}>
                {label}
            </label>
            {error && (
                <p className='text-xs text-app-brown'>{error}</p>
            )}
        </div>
    )
}

export default CheckBoxInput